<div class="component-content">
  @if (!isLoading) {
    <div class="page-navigation">
      <div class="buttons">
        <button
          type="button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onCancel()">
          <div class="button-content">
            <i class="fa-regular fa-times button-icon"></i>
            <div class="button-text">Abbrechen</div>
          </div>
        </button>
        <button
          type="button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onDraft()">
          <div class="button-content">
            <i class="fa-regular fa-floppy-disk button-icon"></i>
            <div class="button-text">Entwurf</div>
          </div>
        </button>
        @if (previewMode) {
          <button
            type="button"
            class="inwi-icon-text-button-medium-secondary"
            (click)="onEdit()">
            <div class="button-content">
              <i class="fa-regular fa-pen button-icon"></i>
              <div class="button-text">Bearbeiten</div>
            </div>
          </button>
        } @else {
          <button
            type="button"
            class="inwi-icon-text-button-medium-secondary"
            (click)="onPreview()">
            <div class="button-content">
              <i class="fa-regular fa-eye button-icon"></i>
              <div class="button-text">Vorschau</div>
            </div>
          </button>
        }
        <button
          type="button"
          class="inwi-icon-text-button-medium-primary"
          (click)="onPublish()">
          <div class="button-content">
            <i class="fa-regular fa-check-double button-icon"></i>

            <div class="button-text">
              {{
                seminar?.isDraft || !editMode
                  ? 'Veröffentlichen'
                  : 'Änderungen speichern'
              }}
            </div>
          </div>
        </button>
        @if (editMode) {
          <button
            type="button"
            class="inwi-icon-button-medium-secondary"
            (click)="contextMenu.toggle($event)">
            <i class="fa-regular fa-ellipsis-vertical button-icon"></i>
          </button>
          <p-menu #contextMenu [model]="contextMenuItems" [popup]="true">
          </p-menu>
        }
      </div>
    </div>

    @if (seminar?.cancelReason) {
      <div class="snackbar-with-icon snackbar-red">
        <i class="fa-regular fa-calendar-xmark"></i>
        {{ seminar.cancelReason }}
      </div>
    }

    <div class="font-bold-display-medium title">
      @if (previewMode) {
        <i class="fa-regular fa-eye"></i>
        <span class="font-bold-display-medium"> Vorschau</span>
      } @else if (editMode) {
        <i class="fa-regular fa-pen"></i>
        <span class="font-bold-display-medium"> Seminar bearbeiten</span>
      } @else {
        <i class="fa-regular fa-plus"></i>
        <span class="font-bold-display-medium"> Seminar hinzufügen</span>
      }
    </div>

    @if (!previewMode) {
      <div class="main-content">
        <form class="flex-c justify-center gap-24" [formGroup]="seminarForm">
          <div
            class="input-formular-title align-self-stretch padding-24-0"
            [class.input-not-empty]="seminarForm.value.name !== ''">
            <input
              type="search"
              class="input-field"
              placeholder="Titel des Seminars"
              formControlName="name" />
            <app-error-message
              [formField]="seminarForm.get('name')"></app-error-message>
          </div>

          <div class="default-form-element default">
            <div class="flex-c align-start gap-24 align-self-stretch">
              <span class="font-medium-headline-large font-color-black">
                Allgemeine Informationen
              </span>
              <div class="flex-c align-start gap-16 align-self-stretch">
                <div class="gap-24 row-gap-16 formular-row-2-inputs">
                  <div class="input-select flex-1-1-0">
                    <div class="input-label" for="lecturer">
                      Dozent auswählen{{
                        fieldRequired(seminarForm.get('lecturer')) ? '*' : ''
                      }}
                    </div>
                    <p-select
                      formControlName="lecturer"
                      [options]="lecturerOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Dozent auswählen..." />
                    <app-error-message
                      [formField]="
                        seminarForm.get('lecturer')
                      "></app-error-message>
                  </div>
                  <div class="input-select flex-1-1-0">
                    <div class="input-label" for="lecturer2">
                      Dozent 2 auswählen
                      {{
                        fieldRequired(seminarForm.get('lecturer2')) ? '*' : ''
                      }}
                    </div>
                    <p-select
                      formControlName="lecturer2"
                      [options]="getLecturer2Options()"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Dozent auswählen..." />
                    <app-error-message
                      [formField]="
                        seminarForm.get('lecturer2')
                      "></app-error-message>
                  </div>
                </div>
                <div class="gap-24 row-gap-16 formular-row-2-inputs">
                  <div class="input-select flex-1-1-0">
                    <div class="input-label" for="category">
                      Kategorie{{
                        fieldRequired(seminarForm.get('category')) ? '*' : ''
                      }}
                    </div>
                    <p-select
                      formControlName="category"
                      [options]="categoryOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Fachbereich auswählen..." />
                    <app-error-message
                      [formField]="
                        seminarForm.get('category')
                      "></app-error-message>
                  </div>
                  <div class="input-select flex-1-1-0">
                    <div class="input-label" for="category2">
                      Kategorie 2{{
                        fieldRequired(seminarForm.get('category2')) ? '*' : ''
                      }}
                    </div>
                    <p-select
                      formControlName="category2"
                      [options]="getCategory2Options()"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Fachbereich auswählen..." />
                    <app-error-message
                      [formField]="
                        seminarForm.get('category2')
                      "></app-error-message>
                  </div>
                </div>
                <div class="flex-r align-start gap-24 align-self-stretch">
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="amount">
                      Plätze{{
                        fieldRequired(seminarForm.get('amount')) ? '*' : ''
                      }}
                    </div>
                    <input
                      class="input-field"
                      formControlName="amount"
                      name="amount"
                      type="text"
                      placeholder="00" />
                    <app-error-message
                      [formField]="
                        seminarForm.get('amount')
                      "></app-error-message>
                  </div>
                  <div class="input-simple flex-1-1-0"></div>
                </div>
                <div class="input-simple align-self-stretch">
                  <div class="input-label-wrapper">
                    <label for="recommendation" class="input-label">
                      Empfehlenswert für{{
                        fieldRequired(seminarForm.get('recommendation'))
                          ? '*'
                          : ''
                      }}
                    </label>
                    <div class="input-label-hint">
                      {{
                        getTextAreaLength(
                          seminarForm.controls['recommendation']
                        )
                      }}
                      /
                      {{ 1200 }}
                    </div>
                  </div>
                  <textarea
                    id="recommendation"
                    name="recommendation"
                    class="input-textarea"
                    rows="1"
                    placeholder="Ergotherapeut*innen, Physiotherapeut*innen, Sprachtherapeut*innen, Ärzt*innen"
                    formControlName="recommendation"></textarea>
                  <app-error-message
                    [formField]="
                      seminarForm.get('recommendation')
                    "></app-error-message>
                </div>
                <div class="input-simple align-self-stretch">
                  <div class="input-label-wrapper">
                    <label for="requirements" class="input-label">
                      Voraussetzung{{
                        fieldRequired(seminarForm.get('requirements'))
                          ? '*'
                          : ''
                      }}
                    </label>
                    <div class="input-label-hint">
                      {{
                        getTextAreaLength(seminarForm.controls['requirements'])
                      }}
                      /
                      {{
                        getMaxLengthFromValidator(
                          seminarForm.controls['requirements']
                        )
                      }}
                    </div>
                  </div>
                  <textarea
                    id="requirements"
                    name="requirements"
                    class="input-textarea"
                    rows="1"
                    placeholder="Keine"
                    formControlName="requirements"></textarea>
                  <app-error-message
                    [formField]="
                      seminarForm.get('requirements')
                    "></app-error-message>
                </div>
                <div class="display-flex align-start gap-24 align-self-stretch">
                  <div class="input-simple flex-1-0-0">
                    <div class="input-label" for="modality">
                      Ort{{
                        fieldRequired(seminarForm.get('modality')) ? '*' : ''
                      }}
                    </div>
                    <div class="radio-buttons">
                      <label
                        for="locationOnline"
                        class="inwi-radio font-regular-body-large">
                        <input
                          id="locationOnline"
                          type="radio"
                          value="online"
                          formControlName="modality" />
                        <span> Online </span>
                      </label>
                      <label
                        for="locationOffline"
                        class="inwi-radio font-regular-body-large">
                        <input
                          id="locationOffline"
                          type="radio"
                          value="offline"
                          formControlName="modality" />
                        <span> Präsenz </span>
                      </label>
                    </div>
                  </div>
                </div>
                @if (seminarForm.get('modality')?.value === 'offline') {
                  <div class="flex-c gap-16 align-self-stretch">
                    <div class="input-simple flex-1-1-0">
                      <div class="input-label" for="addressName">
                        Name des Ortes{{
                          fieldRequired(seminarForm.get('addressName'))
                            ? '*'
                            : ''
                        }}
                      </div>
                      <input
                        class="input-field"
                        formControlName="addressName"
                        name="addressName"
                        id="addressName"
                        type="text"
                        placeholder="Name" />
                      <app-error-message
                        [formField]="seminarForm.get('addressName')">
                      </app-error-message>
                    </div>
                    <div class="gap-24 row-gap-16 formular-row-2-inputs">
                      <div class="input-simple flex-1-1-0">
                        <div class="input-label" for="addressStreet">
                          Straße{{
                            fieldRequired(seminarForm.get('addressStreet'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="addressStreet"
                          name="addressStreet"
                          id="addressStreet"
                          type="text"
                          placeholder="Straße" />
                        <app-error-message
                          [formField]="seminarForm.get('addressStreet')">
                        </app-error-message>
                      </div>
                      <div class="input-simple">
                        <div class="input-label" for="addressHouseNr">
                          Hausnummer{{
                            fieldRequired(seminarForm.get('addressHouseNr'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="addressHouseNr"
                          name="addressHouseNr"
                          id="addressHouseNr"
                          type="text"
                          placeholder="12" />
                        <app-error-message
                          [formField]="seminarForm.get('addressHouseNr')">
                        </app-error-message>
                      </div>
                    </div>
                    <div class="gap-24 row-gap-16 formular-row-2-inputs">
                      <div class="input-simple">
                        <div class="input-label" for="addressZip">
                          PLZ{{
                            fieldRequired(seminarForm.get('addressZip'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="addressZip"
                          name="addressZip"
                          id="addressZip"
                          type="text"
                          placeholder="12345" />
                        <app-error-message
                          [formField]="seminarForm.get('addressZip')">
                        </app-error-message>
                      </div>
                      <div class="input-simple flex-1-1-0">
                        <div class="input-label" for="addressCity">
                          Ort{{
                            fieldRequired(seminarForm.get('addressCity'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="addressCity"
                          name="addressCity"
                          id="addressCity"
                          type="text"
                          placeholder="Ort" />
                        <app-error-message
                          [formField]="seminarForm.get('addressCity')">
                        </app-error-message>
                      </div>
                    </div>
                  </div>
                } @else if (seminarForm.get('modality')?.value === 'online') {
                  <div class="input-simple align-self-stretch">
                    <div class="input-label" for="link">
                      Link{{
                        fieldRequired(seminarForm.get('link')) ? '*' : ''
                      }}
                    </div>
                    <input
                      class="input-field"
                      formControlName="link"
                      name="link"
                      id="link"
                      type="text"
                      placeholder="https://www.example.com" />
                    <app-error-message
                      [formField]="seminarForm.get('link')"></app-error-message>
                  </div>
                  <div class="input-simple align-self-stretch">
                    <div class="input-label" for="platform">
                      Plattform{{
                        fieldRequired(seminarForm.get('platform')) ? '*' : ''
                      }}
                    </div>
                    <input
                      class="input-field"
                      formControlName="platform"
                      name="platform"
                      id="platform"
                      type="text"
                      placeholder="Zoom, Microsoft Teams, Google Meet, etc." />
                    <app-error-message
                      [formField]="
                        seminarForm.get('platform')
                      "></app-error-message>
                  </div>
                  <div class="gap-24 row-gap-16 formular-row-2-inputs">
                    <div class="input-simple flex-1-1-0">
                      <div class="input-label" for="meetingId">
                        Seminar-ID{{
                          fieldRequired(seminarForm.get('meetingId')) ? '*' : ''
                        }}
                      </div>
                      <input
                        class="input-field"
                        formControlName="meetingId"
                        name="meetingId"
                        id="meetingId"
                        type="text"
                        placeholder="1234567890"
                        autocomplete="off" />
                      <app-error-message
                        [formField]="
                          seminarForm.get('meetingId')
                        "></app-error-message>
                    </div>
                    <div class="input-simple flex-1-1-0">
                      <div class="input-label" for="meetingPassword">
                        Seminar-Kennwort{{
                          fieldRequired(seminarForm.get('meetingPassword'))
                            ? '*'
                            : ''
                        }}
                      </div>
                      <input
                        class="input-field"
                        formControlName="meetingPassword"
                        name="meetingPassword"
                        id="meetingPassword"
                        type="text"
                        placeholder="1234567890"
                        autocomplete="off" />
                      <app-error-message
                        [formField]="
                          seminarForm.get('meetingPassword')
                        "></app-error-message>
                    </div>
                  </div>
                }
              </div>

              <div>
                <span class="font-regular-body-large font-color-neutral-10">
                  * Pflichtfelder sind mit einem Sternchen gekennzeichnet.
                </span>
              </div>
            </div>
          </div>
          <div class="default-form-element default">
            <div class="flex-c align-start gap-24 align-self-stretch">
              <span class="font-medium-headline-large font-color-black">
                Kursinhalte
              </span>
              <div class="flex-c align-start gap-16 align-self-stretch">
                <div class="input-simple align-self-stretch">
                  <div class="input-label-wrapper">
                    <label for="description" class="input-label">
                      Beschreibung{{
                        fieldRequired(seminarForm.get('description')) ? '*' : ''
                      }}
                    </label>
                    <div class="input-label-hint">
                      {{
                        getTextAreaLength(seminarForm.controls['description'])
                      }}
                      /
                      {{
                        getMaxLengthFromValidator(
                          seminarForm.controls['description']
                        )
                      }}
                    </div>
                  </div>
                  <textarea
                    id="description"
                    name="description"
                    class="input-textarea"
                    rows="4"
                    placeholder="Beschreibung"
                    formControlName="description"></textarea>
                  <app-error-message
                    [formField]="
                      seminarForm.get('description')
                    "></app-error-message>
                </div>
              </div>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="purposeExplanation" class="input-label">
                    Worum geht es{{
                      fieldRequired(seminarForm.get('purposeExplanation'))
                        ? '*'
                        : ''
                    }}
                  </label>
                  <div class="input-label-hint">
                    {{
                      getTextAreaLength(
                        seminarForm.controls['purposeExplanation']
                      )
                    }}
                    /
                    {{
                      getMaxLengthFromValidator(
                        seminarForm.controls['purposeExplanation']
                      )
                    }}
                  </div>
                </div>
                <textarea
                  id="purposeExplanation"
                  name="purposeExplanation"
                  class="input-textarea"
                  rows="4"
                  placeholder="Worum geht es in diesem Seminar?"
                  formControlName="purposeExplanation"></textarea>
                <app-error-message
                  [formField]="
                    seminarForm.get('purposeExplanation')
                  "></app-error-message>
              </div>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="goals" class="input-label">
                    Ziel{{ fieldRequired(seminarForm.get('goals')) ? '*' : '' }}
                  </label>
                  <div class="input-label-hint">
                    {{ getTextAreaLength(seminarForm.controls['goals']) }}
                    /
                    {{
                      getMaxLengthFromValidator(seminarForm.controls['goals'])
                    }}
                  </div>
                </div>
                <textarea
                  id="goals"
                  name="goals"
                  class="input-textarea"
                  rows="4"
                  placeholder="Was sind die Ziele dieses Seminars?"
                  formControlName="goals"></textarea>
                <app-error-message
                  [formField]="seminarForm.get('goals')"></app-error-message>
              </div>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="purpose" class="input-label">
                    Nutzen für die Praxis{{
                      fieldRequired(seminarForm.get('purpose')) ? '*' : ''
                    }}
                  </label>
                  <div class="input-label-hint">
                    {{ getTextAreaLength(seminarForm.controls['purpose']) }}
                    /
                    {{
                      getMaxLengthFromValidator(seminarForm.controls['purpose'])
                    }}
                  </div>
                </div>
                <textarea
                  id="purpose"
                  name="purpose"
                  class="input-textarea"
                  rows="4"
                  placeholder="Was ist der praktische Nutzen Seminar?"
                  formControlName="purpose"></textarea>
                <app-error-message
                  [formField]="seminarForm.get('purpose')"></app-error-message>
              </div>
            </div>
          </div>
          <div class="default-form-element default">
            <div class="flex-c align-start gap-24 align-self-stretch">
              <span class="font-medium-headline-large font-color-black">
                Fakten
              </span>
              <div class="gap-24 row-gap-16 formular-row-2-inputs">
                <div class="input-simple flex-1-1-0">
                  <div class="input-label" for="courseNumber">
                    Seminarnummer{{
                      fieldRequired(seminarForm.get('courseNumber')) ? '*' : ''
                    }}
                  </div>
                  <input
                    class="input-field"
                    formControlName="courseNumber"
                    name="courseNumber"
                    id="courseNumber"
                    type="text"
                    placeholder="IW-N-00000" />
                  <app-error-message
                    [formField]="
                      seminarForm.get('courseNumber')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-1-0">
                  <div class="input-label">
                    Fobipunkte{{
                      fieldRequired(seminarForm.get('fobiPoints')) ? '*' : ''
                    }}
                  </div>
                  <div class="radio-buttons">
                    <label
                      for="fobiPointsYes"
                      class="inwi-radio font-regular-body-large">
                      <input
                        id="fobiPointsYes"
                        type="radio"
                        [value]="true"
                        formControlName="fobiPoints" />
                      <span> Ja </span>
                    </label>
                    <label
                      for="fobiPointsNo"
                      class="inwi-radio font-regular-body-large">
                      <input
                        id="fobiPointsNo"
                        type="radio"
                        [value]="false"
                        formControlName="fobiPoints" />
                      <span> Nein </span>
                    </label>
                  </div>
                  <app-error-message
                    [formField]="
                      seminarForm.get('fobiPoints')
                    "></app-error-message>
                </div>
              </div>
              <span class="font-medium-title-large font-color-black">
                Konditionen
              </span>
              <div class="flex-c gap-8 align-self-stretch">
                <div class="gap-24 row-gap-16 formular-row-2-inputs">
                  <div
                    [formGroup]="$any(seminarForm.get('regularPriceGroup'))"
                    class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                    <div class="inwi-checkbox">
                      <input
                        type="checkbox"
                        id="regularPriceCheckbox"
                        name="regularPriceCheckbox"
                        formControlName="checkbox"
                        (change)="
                          updateConditionValidators(
                            SeminarConditionType.REGULAR,
                            $event
                          )
                        " />
                    </div>
                    <div class="input-simple flex-1-1-0">
                      <div class="input-label" for="regularPrice">
                        Regulär{{
                          fieldRequired(
                            seminarForm.get('regularPriceGroup').get('price')
                          )
                            ? '*'
                            : ''
                        }}
                      </div>
                      <div class="input-wrapper">
                        <p-inputNumber
                          formControlName="price"
                          mode="decimal"
                          placeholder="00,00"
                          inputId="regularPrice"
                          name="regularPrice"
                          locale="de-DE"
                          minFractionDigits="2"
                          maxFractionDigits="2"
                          fluid />
                        <span class="input-suffix">€</span>
                      </div>

                      <app-error-message
                        [formField]="
                          seminarForm.get('regularPriceGroup').get('price')
                        "></app-error-message>
                    </div>
                  </div>
                  <div
                    [formGroup]="$any(seminarForm.get('earlyBirdPriceGroup'))"
                    class="flex-c gap-8 flex-1-1-0">
                    <div
                      class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                      <div class="inwi-checkbox">
                        <input
                          id="earlyBirdPriceCheckbox"
                          type="checkbox"
                          name="earlyBirdPriceCheckbox"
                          formControlName="checkbox"
                          (change)="
                            updateConditionValidators(
                              SeminarConditionType.EARLY,
                              $event
                            )
                          " />
                      </div>

                      <div class="input-simple flex-1-1-0">
                        <div class="input-label" for="earlyBirdPrice">
                          Frühbucher
                          {{
                            seminarForm
                              .get('earlyBirdPriceGroup')
                              .get('checkbox').value === true
                              ? ''
                              : '(bis __ Wochen vorher)'
                          }}{{
                            fieldRequired(
                              seminarForm
                                .get('earlyBirdPriceGroup')
                                .get('price')
                            )
                              ? '*'
                              : ''
                          }}
                        </div>
                        <div class="input-wrapper">
                          <p-inputNumber
                            formControlName="price"
                            mode="decimal"
                            placeholder="00,00"
                            inputId="earlyBirdPrice"
                            name="earlyBirdPrice"
                            locale="de-DE"
                            minFractionDigits="2"
                            maxFractionDigits="2"
                            fluid />
                          <span class="input-suffix">€</span>
                        </div>

                        <app-error-message
                          [formField]="
                            seminarForm.get('earlyBirdPriceGroup').get('price')
                          "></app-error-message>
                      </div>
                    </div>
                  </div>
                </div>
                @if (
                  seminarForm.get('earlyBirdPriceGroup').get('checkbox')
                    .value === true
                ) {
                  <div
                    [formGroup]="$any(seminarForm.get('earlyBirdPriceGroup'))"
                    class="flex-r gap-24 align-self-stretch">
                    <div class="input-simple flex-1-1-0"></div>
                    <div class="flex-r gap-8 align-center flex-1-1-0">
                      <div class="checkbox-placeholder"></div>

                      <div class="input-simple flex-1-1-0">
                        <div class="input-label" for="earlyBirdDate">
                          Bei Buchung bis{{
                            fieldRequired(
                              seminarForm.get('earlyBirdPriceGroup').get('date')
                            )
                              ? '*'
                              : ''
                          }}
                        </div>
                        <p-datepicker
                          appendTo="body"
                          inputId="earlyBirdDate"
                          formControlName="date"
                          dateFormat="dd.mm.yy"
                          placeholder="TT.MM.JJJJ" />
                        <app-error-message
                          [formField]="
                            seminarForm.get('earlyBirdPriceGroup').get('date')
                          "></app-error-message>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="gap-24 row-gap-16 formular-row-2-inputs">
                <div
                  [formGroup]="$any(seminarForm.get('bedPriceGroup'))"
                  class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                  <div class="inwi-checkbox">
                    <input
                      type="checkbox"
                      id="bedPriceCheckbox"
                      name="bedPriceCheckbox"
                      formControlName="checkbox"
                      (change)="
                        updateConditionValidators(
                          SeminarConditionType.BED,
                          $event
                        )
                      " />
                  </div>
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="bedPrice">
                      BED Mitglied{{
                        fieldRequired(
                          seminarForm.get('bedPriceGroup').get('price')
                        )
                          ? '*'
                          : ''
                      }}
                    </div>
                    <div class="input-wrapper">
                      <p-inputNumber
                        formControlName="price"
                        mode="decimal"
                        placeholder="00,00"
                        inputId="bedPrice"
                        name="bedPrice"
                        locale="de-DE"
                        minFractionDigits="2"
                        maxFractionDigits="2"
                        fluid />
                      <span class="input-suffix">€</span>
                    </div>
                    <app-error-message
                      [formField]="
                        seminarForm.get('bedPriceGroup').get('price')
                      "></app-error-message>
                  </div>
                </div>
                <div
                  [formGroup]="$any(seminarForm.get('logoPriceGroup'))"
                  class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                  <div class="inwi-checkbox">
                    <input
                      type="checkbox"
                      id="logoPriceCheckbox"
                      name="logoPriceCheckbox"
                      formControlName="checkbox"
                      (change)="
                        updateConditionValidators(
                          SeminarConditionType.LOGO,
                          $event
                        )
                      " />
                  </div>
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="logoPrice">
                      LOGO Deutschland Mitglied{{
                        fieldRequired(
                          seminarForm.get('logoPriceGroup').get('price')
                        )
                          ? '*'
                          : ''
                      }}
                    </div>
                    <div class="input-wrapper">
                      <p-inputNumber
                        formControlName="price"
                        mode="decimal"
                        placeholder="00,00"
                        inputId="logoPrice"
                        name="logoPrice"
                        locale="de-DE"
                        minFractionDigits="2"
                        maxFractionDigits="2"
                        fluid />
                      <span class="input-suffix">€</span>
                    </div>
                    <app-error-message
                      [formField]="
                        seminarForm.get('logoPriceGroup').get('price')
                      "></app-error-message>
                  </div>
                </div>
              </div>
              <div class="gap-24 row-gap-16 formular-row-2-inputs">
                <div
                  [formGroup]="$any(seminarForm.get('vdbPriceGroup'))"
                  class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                  <div class="inwi-checkbox">
                    <input
                      type="checkbox"
                      id="vdbPriceCheckbox"
                      name="vdbPriceCheckbox"
                      formControlName="checkbox"
                      (change)="
                        updateConditionValidators(
                          SeminarConditionType.VDB,
                          $event
                        )
                      " />
                  </div>
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="vdbPrice">
                      VDB Mitglied{{
                        fieldRequired(
                          seminarForm.get('vdbPriceGroup').get('price')
                        )
                          ? '*'
                          : ''
                      }}
                    </div>
                    <div class="input-wrapper">
                      <p-inputNumber
                        formControlName="price"
                        mode="decimal"
                        placeholder="00,00"
                        inputId="vdbPrice"
                        name="vdbPrice"
                        locale="de-DE"
                        minFractionDigits="2"
                        maxFractionDigits="2"
                        fluid />
                      <span class="input-suffix">€</span>
                    </div>
                    <app-error-message
                      [formField]="
                        seminarForm.get('vdbPriceGroup').get('price')
                      "></app-error-message>
                  </div>
                </div>
                <div
                  [formGroup]="$any(seminarForm.get('groupPriceGroup'))"
                  class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                  <div class="inwi-checkbox">
                    <input
                      type="checkbox"
                      id="groupPriceCheckbox"
                      name="groupPriceCheckbox"
                      formControlName="checkbox"
                      (change)="
                        updateConditionValidators(
                          SeminarConditionType.OFFICE,
                          $event
                        )
                      " />
                  </div>
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="groupPrice">
                      Praxis (ab 3 Personen){{
                        fieldRequired(
                          seminarForm.get('groupPriceGroup').get('price')
                        )
                          ? '*'
                          : ''
                      }}
                    </div>
                    <div class="input-wrapper">
                      <p-inputNumber
                        formControlName="price"
                        mode="decimal"
                        placeholder="00,00"
                        inputId="groupPrice"
                        name="groupPrice"
                        locale="de-DE"
                        minFractionDigits="2"
                        maxFractionDigits="2"
                        fluid />
                      <span class="input-suffix">€</span>
                    </div>
                    <app-error-message
                      [formField]="
                        seminarForm.get('groupPriceGroup').get('price')
                      "></app-error-message>
                  </div>
                </div>
              </div>
              <div class="gap-24 row-gap-16 formular-row-2-inputs">
                <div
                  [formGroup]="$any(seminarForm.get('vdpPriceGroup'))"
                  class="flex-r gap-8 align-center flex-1-1-0 align-self-stretch">
                  <div class="inwi-checkbox">
                    <input
                      type="checkbox"
                      id="vdpPriceCheckbox"
                      name="vdpPriceCheckbox"
                      formControlName="checkbox"
                      (change)="
                        updateConditionValidators(
                          SeminarConditionType.VDP,
                          $event
                        )
                      " />
                  </div>
                  <div class="input-simple flex-1-1-0">
                    <div class="input-label" for="vdpPrice">
                      VDP Mitglied{{
                        fieldRequired(
                          seminarForm.get('vdpPriceGroup').get('price')
                        )
                          ? '*'
                          : ''
                      }}
                    </div>
                    <div class="input-wrapper">
                      <p-inputNumber
                        formControlName="price"
                        mode="decimal"
                        placeholder="00,00"
                        inputId="vdpPrice"
                        name="vdpPrice"
                        locale="de-DE"
                        minFractionDigits="2"
                        maxFractionDigits="2"
                        fluid />
                      <span class="input-suffix">€</span>
                    </div>
                    <app-error-message
                      [formField]="
                        seminarForm.get('vdpPriceGroup').get('price')
                      "></app-error-message>
                  </div>
                </div>
                <div class="input-simple flex-1-1-0"></div>
              </div>
              <div class="flex-r align-start gap-24 align-self-stretch">
                <div class="input-select flex-1-1-0">
                  <div class="input-label" for="paypalPaymentAvailable">
                    PayPal Zahlung möglich{{
                      fieldRequired(seminarForm.get('paypalPaymentAvailable'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <p-select
                    formControlName="paypalPaymentAvailable"
                    [options]="paypalPaymentAvailableOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="PayPal Zahlung möglich" />
                  <app-error-message
                    [formField]="
                      seminarForm.get('paypalPaymentAvailable')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-1-0"></div>
              </div>
              <span class="font-medium-title-large font-color-black">
                Zusatzinformationen
              </span>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="additionalInfoTitle" class="input-label">
                    Titel{{
                      fieldRequired(seminarForm.get('additionalInfoTitle'))
                        ? '*'
                        : ''
                    }}
                  </label>
                  <div class="input-label-hint">
                    {{
                      getTextAreaLength(
                        seminarForm.controls['additionalInfoTitle']
                      )
                    }}
                    /
                    {{
                      getMaxLengthFromValidator(
                        seminarForm.controls['additionalInfoTitle']
                      )
                    }}
                  </div>
                </div>
                <textarea
                  id="additionalInfoTitle"
                  name="additionalInfoTitle"
                  class="input-textarea"
                  rows="1"
                  placeholder="Titel der Zusatzinformationen"
                  formControlName="additionalInfoTitle"></textarea>
              </div>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="additionalInfoDescription" class="input-label">
                    Beschreibung{{
                      fieldRequired(
                        seminarForm.get('additionalInfoDescription')
                      )
                        ? '*'
                        : ''
                    }}
                  </label>
                  <div class="input-label-hint">
                    {{
                      getTextAreaLength(
                        seminarForm.controls['additionalInfoDescription']
                      )
                    }}
                    /
                    {{
                      getMaxLengthFromValidator(
                        seminarForm.controls['additionalInfoDescription']
                      )
                    }}
                  </div>
                </div>
                <textarea
                  id="additionalInfoDescription"
                  name="additionalInfoDescription"
                  class="input-textarea"
                  rows="4"
                  placeholder="Die Zusatzinformationen"
                  formControlName="additionalInfoDescription"></textarea>
              </div>
              <p-divider class="form-divider"></p-divider>
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="questionsText" class="input-label">
                    Text für Fragen vorab/besonderes Interesse{{
                      fieldRequired(seminarForm.get('questionsText')) ? '*' : ''
                    }}
                  </label>
                  <div class="input-label-hint">
                    {{
                      getTextAreaLength(seminarForm.controls['questionsText'])
                    }}
                    /
                    {{
                      getMaxLengthFromValidator(
                        seminarForm.controls['questionsText']
                      )
                    }}
                  </div>
                </div>
                <textarea
                  id="questionsText"
                  name="questionsText"
                  class="input-textarea"
                  rows="4"
                  placeholder="Interessiert Dich ein Teilbereich/Aspekt besonders? Hast Du eine spezifische Frage zum Thema an den/die Dozierende?"
                  formControlName="questionsText"></textarea>
              </div>
            </div>
          </div>
          <div class="default-form-element default">
            <div class="flex-c align-start gap-24 align-self-stretch">
              <span class="font-medium-headline-large font-color-black">
                Gruppen, Datum und Uhrzeit
              </span>
            </div>
            <div class="flex-c align-self-stretch" formArrayName="dateGroups">
              @for (dateGroup of dateGroups?.controls; track dateGroup) {
                <div
                  class="flex-c align-start gap-24 align-self-stretch"
                  [formGroupName]="$index">
                  <div class="input-simple align-self-stretch">
                    <div class="input-label" for="name">
                      Name der Gruppe{{
                        fieldRequired(dateGroup?.get('name')) ? '*' : ''
                      }}
                    </div>
                    <input
                      class="input-field"
                      formControlName="name"
                      name="name"
                      id="name"
                      type="text"
                      placeholder="Name" />
                  </div>
                  <ng-container formArrayName="dates">
                    @for (date of getDatesArray($index)?.controls; track date) {
                      <div class="date-row" [formGroupName]="$index">
                        <div class="input-simple flex-1-1-0">
                          <label class="input-label" for="date">
                            Datum{{
                              fieldRequired(date?.get('date')) ? '*' : ''
                            }}
                          </label>
                          <p-datepicker
                            appendTo="body"
                            formControlName="date"
                            dateFormat="dd.mm.yy"
                            placeholder="TT.MM.YYYY" />
                        </div>
                        <div class="time-row">
                          <div class="input-simple flex-1-1-0">
                            <label class="input-label" for="startTime">
                              Uhrzeit Anfang{{
                                fieldRequired(date?.get('startTime')) ? '*' : ''
                              }}
                            </label>
                            <input
                              class="input-field"
                              formControlName="startTime"
                              name="startTime"
                              id="startTime"
                              type="time"
                              (change)="calculateDuration(date)"
                              placeholder="HH:mm" />
                          </div>
                          <div class="input-simple flex-1-1-0">
                            <label class="input-label" for="endTime">
                              Uhrzeit Ende{{
                                fieldRequired(date?.get('endTime')) ? '*' : ''
                              }}
                            </label>
                            <input
                              class="input-field"
                              formControlName="endTime"
                              name="endTime"
                              id="endTime"
                              type="time"
                              (change)="calculateDuration(date)"
                              placeholder="HH:mm" />
                          </div>
                        </div>

                        <p-divider
                          layout="vertical"
                          class="form-divider"></p-divider>
                        <div class="flex-r gap-24 flex-1-1-0">
                          <div class="input-simple">
                            <div class="input-label">Dauer:</div>
                            <span class="detail-value">
                              {{ date.get('duration').value ?? 'SS:MM' }}
                            </span>
                          </div>
                          <div class="input-simple flex-1-1-0">
                            <label class="input-label" for="fobiPoints">
                              UE/FP:{{
                                fieldRequired(date?.get('fobiPoints'))
                                  ? '*'
                                  : ''
                              }}
                            </label>
                            <input
                              class="input-field"
                              formControlName="fobiPoints"
                              name="fobiPoints"
                              id="fobiPoints"
                              type="number"
                              placeholder="00" />
                          </div>
                        </div>
                      </div>
                      <p-divider
                        type="dashed"
                        class="divider-with-button align-self-stretch">
                        <div class="flex-r gap-8 bg-general-80 padding-0-8">
                          @if ($index > 0) {
                            <button
                              type="button"
                              class="circle-medium"
                              (click)="removeDateFromGroup(dateGroup, $index)">
                              <i class="fa-solid fa-minus circle-icon"></i>
                            </button>
                          }

                          <button
                            type="button"
                            class="circle-medium"
                            (click)="addDateToGroup(dateGroup, $index)">
                            <i class="fa-solid fa-plus circle-icon"></i>
                          </button>
                        </div>
                      </p-divider>
                    }
                  </ng-container>
                </div>
                @if ($index > 0) {
                  <div class="flex-r justify-end padding-bottom-24">
                    <button
                      type="button"
                      class="inwi-icon-text-button-medium-outline"
                      (click)="removeDateGroup($index)">
                      <div class="button-content">
                        <i class="fa-regular fa-minus button-icon"></i>
                        <div class="button-text">Gruppe löschen</div>
                      </div>
                    </button>
                  </div>
                  <p-divider
                    class="form-divider padding-bottom-48 align-self-stretch">
                  </p-divider>
                }
              }
              <div
                class="flex-r align-self-stretch justify-end padding-bottom-24">
                <button
                  type="button"
                  class="inwi-icon-text-button-medium-outline"
                  (click)="addDateGroup()">
                  <div class="button-content">
                    <i class="fa-regular fa-plus button-icon"></i>
                    <div class="button-text">Neue Gruppe hinzufügen</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="default-form-element default">
            <div class="flex-c align-start gap-24 align-self-stretch">
              <span class="font-medium-headline-large font-color-black">
                Sponsoren
              </span>
              <div class="flex-c align-start gap-16 align-self-stretch">
                <div class="input-simple align-self-stretch">
                  <div class="input-label-wrapper">
                    <label for="description" class="input-label">
                      Sponsor Cards{{
                        fieldRequired(seminarForm.get('sponsorCards'))
                          ? '*'
                          : ''
                      }}
                    </label>
                  </div>
                  <p-multiSelect
                    [options]="sponsorCardOptions"
                    formControlName="sponsorCards"
                    placeholder="Sponsor auswählen"
                    optionValue="id"
                    optionLabel="title">
                    <ng-template let-value pTemplate="selectedItems">
                      <div class="flex-r align-center gap-4">
                        @for (option of value; track $index) {
                          <img
                            [attr.src]="option.image"
                            class="multiselect-image" />
                          <div>
                            {{ option.title
                            }}{{ $index < value.length - 1 ? ', ' : '' }}
                          </div>
                        }
                      </div>
                      @if (!value || value.length === 0) {
                        <div>Sponsor auswählen</div>
                      }
                    </ng-template>
                    <ng-template let-card pTemplate="item">
                      <div class="sponsor-card">
                        <img [attr.src]="card.image" class="image" />
                        <div class="text">
                          <div class="title">{{ card.title }}</div>
                          <div class="description">
                            {{ card.description }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template let-card pTemplate="footer">
                      <b>
                        {{
                          seminarForm.get('sponsorCards').value
                            ? seminarForm.get('sponsorCards').value.length
                            : 0
                        }}
                      </b>
                      {{
                        (seminarForm.get('sponsorCards').value
                          ? seminarForm.get('sponsorCards').value.length
                          : 0) === 1
                          ? 'Sponsor Card'
                          : 'Sponsor Cards'
                      }}
                      ausgewählt.
                    </ng-template>
                  </p-multiSelect>
                  <app-error-message
                    [formField]="
                      seminarForm.get('sponsorCards')
                    "></app-error-message>
                </div>
              </div>
            </div>
          </div>
          <app-file-manager
            [useCategoryColors]="false"
            [seminarId]="seminar?.id"
            [seminarCategory]="seminar?.category1"
            [listView]="true"
            [isAdminView]="true"
            [allowRename]="true"
            [allowDelete]="true">
          </app-file-manager>
        </form>
      </div>
    }
    @if (previewMode) {
      <app-seminar-preview
        [seminar]="seminar"
        [sponsorCards]="selectedSponsorCards"></app-seminar-preview>
    }
  } @else {
    <div class="loading-wrapper">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="100">
      </mat-progress-spinner>
    </div>
  }
</div>
